import { useGetTermsAndConditions } from "@/hooks/queryHooks/configHooks";
import { Spinner } from "@repo/ui/components/Base/Spinner";

export const TermsAndConditions = () => {
  const { data, loaded } = useGetTermsAndConditions();

  if (!loaded) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }

  if (!data) {
    return <div>Not Found</div>;
  }

  return (
    <div className="max-w-screen-md m-auto h-full">
      <h1 className="text-2xl font-bold mb-8">Terms and Conditions</h1>
      {data && (
        <iframe
          src={data.url}
          title="Terms and Conditions"
          className="w-full h-full"
        />
      )}
    </div>
  );
};
